import { Popup } from "@oxygen/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { closeAccountPopup, logIn, showAccountIcon } from "../actionCreator";
import { PopupHeader } from "../components/PopupHeader";
import { PopupContent } from "../components/PopupContent";
import CarwaleLoginApi from "../apis";
import { getUserInfo } from "../utils";
import SpeedometerLoader from "GlobalComponent/SpeedometerLoader";
import { makeCancelable } from "GlobalUtils/CancelablePromise";
import getThemeClasses from "@oxygen/theme";
import styles from "./scss/Account.desktop.module.scss";

const containerClasses = getThemeClasses(`
  pl-9;
  pr-9;
  pt-3;
  pb-6;
`);
const popupHeightClasses = getThemeClasses(`
  height-auto;
`);
/**
 * This component renders Popup containing Three forms:
 * 1.SignUp form
 * 2.Login form
 * 3.ForgotPassword form
 */
let apiPromise = null;

const Account = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const accountRef = useRef(null);
  const [isFetching, setIsFetching] = useState(false);
  const { isActive, screen } = useSelector(state => state.account || {});

  const handleSignedInApiResponse = response => {
    setIsFetching(false);
    if (!response) {
      console.log("Invalid response from checkSignedIn api");
      return;
    }
    if (response.isLoggedIn) {
      const userInfo = getUserInfo(response);
      dispatch(logIn(userInfo));
    }
    dispatch(showAccountIcon(true));
  };

  const handleUserSignedInStatus = () => {
    setIsFetching(true);
    apiPromise && apiPromise.cancel();
    apiPromise = makeCancelable(CarwaleLoginApi.cwCheckSingnedIn());
    apiPromise.promise.then(handleSignedInApiResponse).catch(() => {
      setIsFetching(false);
      console.log("Cant fetch user signedIn status");
    });
  };

  useEffect(() => {
    handleUserSignedInStatus();
    return () => {
      apiPromise && apiPromise.cancel();
    };
  }, []);

  const handleClose = () => {
    dispatch(closeAccountPopup());
  };
  return (
    <Popup
      handleClose={handleClose}
      headContent={<PopupHeader isActive={isActive} screen={screen} />}
      heightClassName={popupHeightClasses}
      widthClassName={styles.popupWidth}
      direction="center"
      isActive={isActive}
      history={history}
      roundedCornersOnDevice="desktop"
    >
      <>
        {isFetching && <SpeedometerLoader />}
        {isActive && (
          <div className={containerClasses} ref={accountRef}>
            <PopupContent screen={screen} accountRef={accountRef} />
          </div>
        )}
      </>
    </Popup>
  );
};

export default Account;
